const manifest_path = "https://assets.sonadier.io/packs/manifest.json"

const asset_host = "https://assets.sonadier.io"

export { asset_host, manifest_path }
